import { generate } from '../../command';
import { Point } from '../../type/common.interface';

export function generateCmds(transformedCycles: Point[][]) {
    const cmds = [{ type: 'B' }].concat(transformedCycles.map(cycle => generate(cycle)).flat()).concat({ type: 'Z' });
    return cmds;
}
